import { render, staticRenderFns } from "./ContasAPagar.vue?vue&type=template&id=36aaff4f&scoped=true&"
import script from "./ContasAPagar.vue?vue&type=script&lang=js&"
export * from "./ContasAPagar.vue?vue&type=script&lang=js&"
import style0 from "./ContasAPagar.vue?vue&type=style&index=0&id=36aaff4f&prod&lang=scss&scoped=true&"
import style1 from "./ContasAPagar.vue?vue&type=style&index=1&id=36aaff4f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aaff4f",
  null
  
)

export default component.exports